export default __webpack_public_path__ + "static/media/manage_accounts.1ecdefbc.svg";